var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 277,
    viewBox: "0 0 257 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 153.889,
    height: 82.0741,
    fill: "#0364FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8135,
    width: 82.0741,
    height: 277,
    fill: "#0364FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.443 82.0741C238.107 82.0741 256.48 63.7012 256.48 41.037C256.48 18.3729 238.107 0 215.443 0C192.779 0 174.406 18.3729 174.406 41.037C174.406 63.7012 192.779 82.0741 215.443 82.0741Z",
    fill: "#0364FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorus);
export default __webpack_public_path__ + "static/media/torus.8cba2e0f41c81a0e2c067ef5c5407b43.svg";
export { ForwardRef as ReactComponent };